import type { DropdownOption } from "../Dropdown/Dropdown";
import { storyFilterColumnIcon } from "./storyFilterColumnIcon";
import type { StoryFilterColumn, StoryFilterColumnType } from "./StoryFilterBar.types";

/** Group headings of the column picker, in display order. */
export const STORY_FILTER_COLUMN_GROUPS: { type: StoryFilterColumnType; label: string }[] = [
  { type: "number", label: "Measures" },
  { type: "measure", label: "Calculations" },
  { type: "date", label: "Dates" },
  { type: "text", label: "Dimensions" },
  { type: "geo", label: "Geographic" },
];

/**
 * Shapes columns for the generic `Dropdown` (variant="picker") used as the column menu: grouped
 * (Measures, Calculations, Dates, Dimensions, Geographic), each group's columns in the order given.
 */
export const toStoryFilterColumnOptions = (
  columns: StoryFilterColumn[],
): DropdownOption<string>[] =>
  STORY_FILTER_COLUMN_GROUPS.flatMap(({ type, label }) =>
    columns
      .filter((column) => column.type === type)
      .map((column) => ({
        value: column.id,
        label: column.label,
        icon: storyFilterColumnIcon(column.type),
        disabled: column.disabled,
        group: label,
        meta: column.meta,
      })),
  );

/**
 * The drill-down field picker's two tabs (Ruchi's call, 2026-10-16): "Hierarchy"
 * lists only fields that belong to a natural hierarchy (e.g. City → State →
 * Country); "Dimensions" lists every other attribute, dimension and date, never
 * a measure (a chart can't be regrouped by one). A field is never shown twice.
 */
export const toDrillDownFieldTabOptions = (
  columns: StoryFilterColumn[],
): { hierarchy: DropdownOption<string>[]; columns: DropdownOption<string>[] } => {
  const hierarchyColumns = columns.filter((column) => column.hierarchy != null);
  const regularColumns = columns.filter(
    (column) => column.hierarchy == null && column.type !== "number" && column.type !== "measure",
  );
  return {
    hierarchy: toStoryFilterColumnOptions(hierarchyColumns),
    columns: toStoryFilterColumnOptions(regularColumns),
  };
};
